import FileReferenceDefinition from '../FileReferenceDefinition';

const definition: FileReferenceDefinition = {
  name: 'FocusedInputFieldType',
  type: 'enum',
  description: 'Indicates the type of input field focused.',
  members: [
    {
      name: 'Text',
      type: 'value',
      description: 'Indicates that a text input field is focused. Examples of a text input field include an `input` element, a `textarea` element, and an element with a `contentEditable` attribute.'
    },
    {
      name: 'None',
      type: 'value',
      description: 'Indicates that no input field is focused.'
    },
  ]
};
export default definition;

